import { getCountryNameByCountryCode, getStatusDescriptionFromStatusValue, getOrderTypeText } from '../../../../../utils/utility';
import { getDateWithSpecificFormat } from '../../../../data-transform';


export default function myQuotesTableColumns(config) {
    const { quoteList = [], customerType, userType, vendorName } = config.data;
    let result = {};
    let tableData = [];
    let prefillingData = {};
    const isCustomer = userType === "legal_entity" || userType === "Customer" || userType === "customer" || userType === "regional" || userType === "master" || userType === "hp_employee" || userType === "hp_partner";

    quoteList.forEach(quote => {
        let row = [];
        const rowId = quote.quoteId;
        const winningDeliveryPartners = Array.isArray(quote.winningDeliveryPartner)
            ? quote.winningDeliveryPartner.filter(option => option)
            : (quote.winningDeliveryPartner ? [quote.winningDeliveryPartner] : []);
        const isWinningVendor = userType === "Vendor" && winningDeliveryPartners.includes(vendorName);
        config.columns.forEach(column => {
            let columnValue = "";
            let linkDestination = "";

            let displayAsIs = column.data.displayInBodyAsIs;
            if (column.data.displayInBodyAs === "string") {
                if (column.id === "quoteCreationDate") {
                    columnValue = getDateWithSpecificFormat(quote.createdDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "orderType") {
                    columnValue = getOrderTypeText(quote.orderType) || "";
                    displayAsIs = true;
                }
                else if (column.id === "country") {
                    columnValue = getCountryNameByCountryCode(quote.countryCode) || "";
                    displayAsIs = true;
                }
                else if (column.id === "legalEntityName") {
                    columnValue = quote.legalEntity || "";
                    displayAsIs = true;
                }
                else if (column.id === "collectionCity") {
                    columnValue = quote.collectionCity || "-";
                    displayAsIs = true;
                }
                else if (column.id === "status") {
                    if (quote.status === 'PENDING_HP_REVIEW' && isCustomer) {
                        columnValue = getStatusDescriptionFromStatusValue('PENDING_PRICES')
                    }
                    else {
                        columnValue = getStatusDescriptionFromStatusValue(quote.status) || "";
                        displayAsIs = true;
                    }

                }
                else if (column.id === "priceUploadedDate") {
                    columnValue = getDateWithSpecificFormat(quote.priceUploadedDate) || "";
                    displayAsIs = true;
                }
                else if (column.id === "qtyOfAssets") {
                    columnValue = quote.assetQty || "";
                    displayAsIs = true;
                }
                else if (column.id === "currency") {
                    columnValue = quote.currencyCode || "";
                    displayAsIs = true;
                }
                else if (column.id === "quotedNetValue") {
                    if (customerType === 'indirect') {
                        columnValue = quote.netValue?.toFixed(2)
                    } else {
                        columnValue = isCustomer ? quote.cnetValue?.toFixed(2) : quote?.vnetValue?.toFixed(2);
                    }
                    
                    if (quote.status === 'PENDING_PRICES') {
                        columnValue = '';
                    }
                    displayAsIs = true;
                }
                else if (column.id === "quotedHWBuybackValue") {
                    if (quote.status === 'PENDING_PRICES') {
                        columnValue = '';
                    } else {
                        columnValue = isCustomer ? quote?.chwBuyBackValue?.toFixed(2) : quote?.vhwBuyBackValue?.toFixed(2);
                    }
                    displayAsIs = true;
                }
                else if (column.id === "hpQuotedHWBuybackValue") {
                    columnValue = quote?.vhpquotedHWBuybackValue?.toFixed(2) || "";
                }
                else if (column.id === "vendorQuotedNetValueVendor") {
                    columnValue = quote.vnetValue !== null ? quote.vnetValue : "";
                }
                else if (column.id === "vendorQuotedHWBuybackValueVendor") {
                    columnValue = quote.vhwBuyBackValue !== null ? quote.vhwBuyBackValue : "";
                }
                else if (column.id === "vendorQuotedServiceCostsVendor") {
                    columnValue = quote.vserviceCost !== null ? quote.vserviceCost : "";
                }
                else if (column.id === "vendorQuotedRevitalizeFees") {
                    columnValue = quote?.vhardwareRevitalizeFees?.toFixed(2) || "";
                }
                else if (column.id === "quotedServiceCost") {
                    if (quote.status === 'PENDING_PRICES') {
                        columnValue = '';
                    } else {
                        columnValue = isCustomer ? quote?.cserviceCost?.toFixed(2) : quote?.vserviceCost?.toFixed(2);
                    }
                    displayAsIs = true;
                }
                else if (column.id === "currencyCode") {
                    columnValue = quote.currencyCode || "";
                    displayAsIs = true;
                }
                else if (column.id === "company") {
                    columnValue = quote.company || "";
                    displayAsIs = true;
                }
                else if (column.id === "revitalizeQuote") {
                    columnValue = quote.revitalizeQuote !== null ? quote.revitalizeQuote : "";
                }
                else if (column.id === "quantityofHpRevitalizeAssetsQuoted") {
                    columnValue = quote.numberOfRevitalizeAssets !== null ? quote.numberOfRevitalizeAssets : "";
                }
                else if (column.id === "revitalizeHpPricesStatus") {
                    columnValue = getStatusDescriptionFromStatusValue(quote.hpRevDirStatus) || "";
                }
                else if (column.id === "vendorQuoteStatus") {
                    columnValue = (quote.status === "ACCEPTED" || quote.status === "LOST")
                        ? getStatusDescriptionFromStatusValue(isWinningVendor ? "ACCEPTED" : "LOST")
                        : getStatusDescriptionFromStatusValue(quote.status) || "";
                    displayAsIs = true;
                }
                else if (column.id === "countriesAssignedToVendor") {
                    columnValue = (quote.status === "ACCEPTED" && isWinningVendor && quote.winingCountryVendor && quote.winingCountryVendor[vendorName])
                        ? quote.winingCountryVendor[vendorName]
                        : "-";
                    displayAsIs = true;
                }
            }
            else if (column.data.displayInBodyAs === "link") {
                if (column.id === "quoteNumber" && quote.quoteId) {
                    displayAsIs = true;
                    columnValue = quote.quoteId;
                    linkDestination = customerType === "indirect" && userType !== 'Vendor' ? '/recycle' : '/my-quotes/quote-detail/' + quote.quoteId;
                    prefillingData = { quoteId: quote.quoteId, prefilledCountryCode: quote.countryCode };
                }
            }

            row.push({
                [column.id]: {
                    columnId: column.id,
                    id: column.id + "|" + rowId,
                    type: column.data.displayInBodyAs,
                    value: columnValue,
                    width: column.width,
                    displayAsIs: displayAsIs,
                    linkDestination: linkDestination,
                    prefillingData: prefillingData,
                    showInMobileViewAs: column.showInMobileViewAs
                }
            });
        });

        tableData.push({
            id: rowId,
            data: row
        });
    });


    result['columns'] = config.columns;
    result['data'] = tableData;

    return result;
}
